import React, { useState } from "react";
import { Paginator } from 'primereact/paginator';

export default function MoveScroller( { count , setNewPos} ) {

    console.log( "count = " + count )

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);



    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);

        var obj = {
            first: event.first,
            len: event.rows
        }

        setNewPos(obj);
    };

    return (
        <div className="card">
            <Paginator first={first} rows={rows} totalRecords={count} rowsPerPageOptions={[10, 20, 30]} onPageChange={onPageChange} />
        </div>
    );
}